import { Component, inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { BreadcrumbService } from '@core/services/breadcrumb-service/BreadcrumbService';
import { MenuService } from '@core/services/menu-service/menu.service';
import { UserService } from '@core/services/oauth-service/user.service';

@Component({
  selector: 'app-dummy-dashboard',
  templateUrl: '../shared/dashboard.component.html',
  styleUrls: ['../shared/dashboard.component.scss'],
  standalone: false,
})
export class DashboardComponent implements OnInit {
  readonly menuService = inject(MenuService);
  readonly router = inject(Router);
  readonly breadcrumbService = inject(BreadcrumbService);
  readonly userService = inject(UserService);
  readonly matDialog = inject(MatDialog);

  menu = null;
  userInfo = '';
  viewTitle = 'Herzlich willkommen im REM-Portal';
  linksTitle = '';
  links: Array<any> = [];
  linksAnonymous: Array<any> = [
    {
      label: 'Anmeldung',
      items: [
        {
          id: 'login',
          label: 'Login',
          icon: '',
          onClick: () => {
            this.userService.login();
          },
        },
      ],
    },
    {
      label: 'Support',
      items: [
        {
          id: 'support',
          label: 'Support',
          icon: '',
          onClick: () => {
            this.router.navigateByUrl('/support');
          },
        },
      ],
    },
  ];
  cardsTitle = 'Ihre Meldungen';
  cards: Array<any> = [];

  ngOnInit(): void {
    this.menuService.menuChange$.subscribe({
      next: data => {
        this.menu = this.mapMenu(data);
      },
    });
    this.breadcrumbService.resetBreadcrumbs();

    this.userInfo = this.userService.accountDisplayName;
  }

  mapMenu(menu: any) {
    if (menu['side-nav'] && menu['side-nav'].length > 0) {
      const sideNav = [];
      menu['side-nav'].forEach(item => {
        const subItems = [];
        if (item.items && item.items.length > 0) {
          item.items.forEach(subItem => {
            subItems.push({
              id: subItem.id,
              label: subItem.label,
              tooltip: subItem.tooltip,
              icon: subItem.icon && subItem.icon !== '' ? subItem.icon : 'box',
              onClick: () => {
                this.router.navigateByUrl(subItem.link, {
                  state: { menuId: subItem.id },
                });
              },
            });
          });
        }
        sideNav.push({
          label: item.label,
          items: subItems,
        });
      });
      this.links = sideNav;
    }
  }
}
